<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const badges = ['stripe', 'gdpr', 'waiting', 'no_fee'] as const
</script>

<template>
  <section class="bg-white py-16">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <p class="text-center text-slate-400 text-xs font-semibold uppercase tracking-widest mb-10">
        {{ t('participants_lp.trust.label') }}
      </p>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <div
          v-for="badge in badges"
          :key="badge"
          class="bg-slate-50 rounded-xl p-6 border border-slate-100 text-center"
        >
          <div class="w-8 h-8 text-sky-600 mx-auto mb-3">
            <!-- Stripe -->
            <svg v-if="badge === 'stripe'" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <rect x="6" y="6" width="28" height="28" rx="4" stroke="currentColor" stroke-width="2.5" />
              <path d="M13 20h14M13 26h8M13 14h8" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
            </svg>
            <!-- GDPR -->
            <svg v-else-if="badge === 'gdpr'" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <path d="M20 4L8 10v10c0 7.18 5.14 13.9 12 15.5C27.86 33.9 32 27.18 32 20V10L20 4z" stroke="currentColor" stroke-width="2.5" stroke-linejoin="round" />
              <path d="M14 20l4 4 8-8" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <!-- Waiting list -->
            <svg v-else-if="badge === 'waiting'" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <circle cx="20" cy="20" r="14" stroke="currentColor" stroke-width="2.5" />
              <path d="M20 12v8l5 5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <!-- No fee -->
            <svg v-else viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <circle cx="20" cy="20" r="14" stroke="currentColor" stroke-width="2.5" />
              <path d="M20 12v2M20 26v2M15 17a5 5 0 0110 0c0 3-5 5-5 5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
            </svg>
          </div>
          <h3 class="text-sm font-bold text-slate-900">{{ t(`participants_lp.trust.${badge}_title`) }}</h3>
          <p class="text-xs text-slate-500 mt-2 leading-relaxed">{{ t(`participants_lp.trust.${badge}_body`) }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
